import { render, staticRenderFns } from "./service_shop.vue?vue&type=template&id=719e49e7&scoped=true"
import script from "./service_shop.vue?vue&type=script&lang=js"
export * from "./service_shop.vue?vue&type=script&lang=js"
import style0 from "./service_shop.vue?vue&type=style&index=0&id=719e49e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719e49e7",
  null
  
)

export default component.exports